import React from "react";
import { getImgPath } from "../common/helper";

function BookingCountersKn() {
  return (
    <div className="body_style">
      <div className="letters-color-section">
        <h3 className="letters-color-section-main-heading">
          ಬುಕಿಂಗ್ ಕೌಂಟರ್‌ಗಳು
        </h3>
        <div className="letters-color-section-sub-heading-section">
          <h5 className="letters-color-section-sub-heading">
            ಕರ್ನಾಟಕ ರಾಜ್ಯದಲ್ಲಿ NEKRTC ಕಾನೂನುವ್ಯಾಪ್ತಿಯಲ್ಲಿ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳು
          </h5>
        </div>
        <div className="letters-color-section-table-section">
          <div className="heading-main">
            <div className="heading">
              <table>
                <tr>
                  <td>1.</td>
                  <td>
                    KSRTC ಮತ್ತು ಸಿಸ್ಟರ್ ಕಾರ್ಪೊರೇಷನ್‌ಗಳು ನಿರ್ವಹಿಸುವ ಬುಕಿಂಗ್
                    ಕೌಂಟರ್‌ಗಳು
                  </td>
                  <td className="td-third">
                    <span>
                      <img
                        src={getImgPath("/img/aboutus/download_icon.png")}
                        alt="download"
                        width="18"
                        height="22"
                      />
                    </span>
                    <span>Download</span>
                  </td>
                </tr>
                <tr>
                  <td>2.</td>
                  <td>
                    ಬೆಂಗಳೂರು ನಗರ ಮತ್ತು ಉಪನಗರ ಪ್ರದೇಶದಲ್ಲಿ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳು
                  </td>
                  <td className="td-third">
                    <span>
                      <img
                        src={getImgPath("/img/aboutus/download_icon.png")}
                        alt="download"
                        width="18"
                        height="22"
                      />
                    </span>
                    <span>Download</span>
                  </td>
                </tr>
                <tr>
                  <td>3.</td>
                  <td>
                    ಕರ್ನಾಟಕ ರಾಜ್ಯದಲ್ಲಿ KSRTC ಕಾನೂನುವ್ಯಾಪ್ತಿಯಲ್ಲಿ ಫ್ರಾಂಚೈಸಿ
                    ಕೌಂಟರ್‌ಗಳು
                  </td>
                  <td className="td-third">
                    <span>
                      <img
                        src={getImgPath("/img/aboutus/download_icon.png")}
                        alt="download"
                        width="18"
                        height="22"
                      />
                    </span>
                    <span>Download</span>
                  </td>
                </tr>
                <tr>
                  <td>4.</td>
                  <td>
                    ಕರ್ನಾಟಕ ರಾಜ್ಯದಲ್ಲಿ KKRTC ಕಾನೂನುವ್ಯಾಪ್ತಿಯಲ್ಲಿ ಫ್ರಾಂಚೈಸಿ
                  </td>
                  <td className="td-third">
                    <span>
                      <img
                        src={getImgPath("/img/aboutus/download_icon.png")}
                        alt="download"
                        width="18"
                        height="22"
                      />
                    </span>
                    <span>Download</span>
                  </td>
                </tr>
                <tr>
                  <td>5.</td>
                  <td>
                    ಕರ್ನಾಟಕ ರಾಜ್ಯದಲ್ಲಿ NWKRTC ನ್ಯಾಯವ್ಯಾಪ್ತಿಯಲ್ಲಿ ಫ್ರಾಂಚೈಸಿ
                    ಕೌಂಟರ್‌ಗಳು
                  </td>
                  <td className="td-third">
                    <span>
                      <img
                        src={getImgPath("/img/aboutus/download_icon.png")}
                        alt="download"
                        width="18"
                        height="22"
                      />
                    </span>
                    <span>Download</span>
                  </td>
                </tr>
                <tr>
                  <td>6.</td>
                  <td>ನೆರೆಯ ರಾಜ್ಯಗಳಲ್ಲಿ ಫ್ರಾಂಚೈಸಿ ಕೌಂಟರ್‌ಗಳು</td>
                  <td className="td-third">
                    <span>
                      <img
                        src={getImgPath("/img/aboutus/download_icon.png")}
                        alt="download"
                        width="18"
                        height="22"
                      />
                    </span>
                    <span>Download</span>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default BookingCountersKn;
